import { SvgIconProps, Theme } from '@mui/material';
import { WbCounter, WbListGroupItem, WbText } from '@workbench/react';
import React, { MouseEventHandler } from 'react';
import { makeStyles } from 'tss-react/mui';
import { grey as greyColor } from '@mercedes-benz/mui5-theme/build/main/lib/Colors';

const useStyles = makeStyles()((theme: Theme) => ({
    textColor: {
        color: greyColor[35],
        '--size': '24px',
    },
    icon: {
        marginRight: theme.spacing(1),
    },
}));
export interface TaskMenuItem {
    label: string;
    counter: number;
    handle?: MouseEventHandler<HTMLWbListGroupItemElement>;
    disabled?: boolean;
    icon?: React.ComponentType<SvgIconProps>;
}

function TaskMenuItem(props: Readonly<TaskMenuItem>) {
    const { classes } = useStyles();

    return props.counter > 0 ? (
        <WbListGroupItem key={props.label} interactive onClick={props.handle}>
            <span slot="icon"> {props.icon && <props.icon className={classes.icon} />}</span>

            <WbText className={classes.textColor}>{props.label}</WbText>

            {props.counter > 0 && <span slot="meta">{<WbCounter max={99} value={props.counter} />}</span>}
        </WbListGroupItem>
    ) : null;
}

export default TaskMenuItem;
